import 'angular';

import { CapricornStates }        from './capricorn.states.ajs';
import { CapricornSettingsCtrl }  from './capricorn.settings';
import { CreateCapricornCsvCtrl } from './capricorn.create-csv';

angular.module('workshop.capricorn', [])
  .config(CapricornStates)
  .controller('CapricornSettingsCtrl', CapricornSettingsCtrl)
  .controller('CreateCapricornCsvCtrl', CreateCapricornCsvCtrl);
